import React from 'react';
import { useIntl } from 'umi';
import { isNotEmpty } from '@intelligence/v3/utils/common';
import { newMathFormat } from '@intelligence/utils/commonUtils';
import { getPreviewTitle } from '../previewHelpers';

import type { IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';

interface INumberRangePreviewProps {
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}

const NumberRangePreview: React.FC<INumberRangePreviewProps> = (props) => {
  const { item, valueItem } = props;
  const { formatMessage } = useIntl();
  const { min, max } = valueItem || {};
  const hasMin = isNotEmpty(min);
  const hasMax = isNotEmpty(max);

  let content = formatMessage({ id: 'dbi_filterSave_none' });
  if (hasMin && hasMax) {
    content = `${newMathFormat(min, true)} ~ ${newMathFormat(max, true)}`;
  } else if (hasMin && !hasMax) {
    content = `${newMathFormat(min, true)} ~ `;
  } else if (!hasMin && hasMax) {
    content = `~ ${newMathFormat(max, true)}`;
  }

  return (
    <>
      <span className="model-form-text">{getPreviewTitle(item, formatMessage)}</span>
      <span className="model-form-context">{content}</span>
    </>
  );
};

export default NumberRangePreview;
